/**
 * Top-level error boundary.
 *
 * The legacy index.html installed a `window.onerror` handler that, on any error
 * originating in doctor_dashboard.js, replaced the entire document with a red
 * stack trace — shown to end users, in production. This keeps the diagnostic
 * detail (behind a disclosure, and always in the console) while showing the user
 * something recoverable.
 */

import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Uncaught render error:', error);
    console.error('[ErrorBoundary] Component stack:', info?.componentStack);
    this.setState({ info });
  }

  handleReload = () => {
    this.setState({ error: null, info: null });
    window.location.reload();
  };

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="flex min-h-screen items-center justify-center bg-[#020617] p-6">
        <div className="glass-panel w-full max-w-2xl rounded-2xl p-8 text-center">
          <h1 className="mb-2 text-xl font-bold text-white">حدث خطأ غير متوقع</h1>
          <p className="mb-6 text-sm text-slate-400">
            تم تسجيل تفاصيل الخطأ. يمكنك إعادة تحميل الصفحة للمتابعة.
          </p>

          <button type="button" onClick={this.handleReload} className="btn-primary mx-auto">
            إعادة تحميل الصفحة
          </button>

          <details className="mt-6 text-right" dir="ltr">
            <summary className="cursor-pointer text-xs text-slate-500 hover:text-slate-300">
              Technical details
            </summary>
            <pre className="custom-scrollbar mt-3 max-h-64 overflow-auto rounded-lg bg-slate-950 p-3 text-left text-[11px] leading-relaxed text-red-300">
{String(error?.stack || error)}
{info?.componentStack ? `\n\nComponent stack:${info.componentStack}` : ''}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
